import { get, post } from '@api/request';

export async function fetchConfigurations(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/bpprendition/configuration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateConfiguration(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/bpprendition/configuration`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchUIOptions(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/bpprendition/configuration/uioptions`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyBPPRenditionLoadData(
  { appraisalService },
  authenticationToken,
  { pID, pYear, pVersion, pRollCorr }
) {
  const url = `${appraisalService}/appraisal/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/bpprenditionprocess/loaddata`;
  const { body } = await get(authenticationToken, url);
  return body;
}